import React, { useState, useEffect } from 'react';
import { Link, useParams } from 'react-router-dom';
import { useStoreActions } from 'easy-peasy';
import { toast } from 'react-toastify';

// Import Components
import Table from '../../Table';
import Modal from '../../Modal_2';

// Import tools
import { dateFormat } from '../../../tools/date';

// import logo
import Search from '../../../../assets/images/svg/search.svg';
import DeleteIcon from '../../../../assets/images/svg/delete-icon.svg';
import AttentionIcon from '../../../../assets/images/svg/attention.svg';
import More from '../../../../assets/images/svg/more.svg';
import Eye from '../../../../assets/images/svg/eye.svg';

const BreakDowns = () => {
  const { idTruck } = useParams();

  const getListBreakdowns = useStoreActions((actions) => actions.middleware.BreakdownMiddleware.getListBreakdowns);
  const deleteBreakdown = useStoreActions((actions) => actions.middleware.BreakdownMiddleware.deleteBreakdown);

  const [breakdowns, setBreakdowns] = useState([]);
  const [textSearch, setTextSearch] = useState('');
  const [breakdownsList, setBreakdownsList] = useState({});
  const [breakdownSelected, setBreakdownSelected] = useState({});
  const [showModal, setShowModal] = useState(false);

  // func filter search, Listen
  useEffect(() => {
    if (textSearch === '') {
      setBreakdownsList(breakdowns);
    } else {
      const tabFilter = breakdowns.filter((element) => element.name.toLowerCase().includes(textSearch.toLowerCase()));
      setBreakdownsList(tabFilter);
    }
  }, [textSearch, breakdowns]);

  //  🌱🌱 Request call List Breakdowns  🌱🌱
  const callListBreakdowns = async () => {
    try {
      const res = await getListBreakdowns(idTruck);
      setBreakdowns(res);
    } catch (error) {
      console.log('error', error);

      toast.error('❗️ Une erreur est survenue lors du chargement de la liste des contraventions');
    }
  };
  //   🌱🌱 Request delete Breakdown  🌱🌱
  const removeBreakdown = async () => {
    try {
      await deleteBreakdown(breakdownSelected.id);
      callListBreakdowns();
      setShowModal(false);
      setBreakdownSelected(null);
      toast.success('❗️ La panne a bien été supprimée');
    } catch (error) {
      toast.error('❗️ Une erreur est survenue lors de la suppression de la contravention');
    }
  };

  //  🌱🌱  Delete action  🌱🌱
  const callDeleteBreakdown = (contravention) => {
    setShowModal(true);
    setBreakdownSelected(contravention);
  };

  //  🌱🌱  First effect  🌱🌱
  useEffect(() => {
    callListBreakdowns();
  }, []);

  return (
    <>
      <section className="px-4 md:px-9">
        {/* div search bar */}
        {/* <div className="relative mt-12">
          <input
            type="text"
            placeholder="Rechercher une panne"
            className="w-full py-3 pl-10 border-none rounded-xl placeholder:text-blue-admin inputFocus"
            onInput={(e) => setTextSearch(e.target.value)}
          />
          <img
            src={Search}
            alt="search icon"
            className="absolute left-0 flex items-center w-8 h-5 pl-3 top-4"
          />
        </div> */}
        {/* Table list Breakdowns */}
        <div className="mt-9">
          <Table>
            <thead>
              <tr>
                <th>Date de la panne</th>
                <th>Nature de la panne</th>
                <th>Document</th>
                <th>Montant des frais de réparation</th>
                <th>Statut</th>
                <th className="flex justify-end">Actions</th>
              </tr>
            </thead>
            <tbody>
              {breakdownsList.length ? (
                breakdownsList.map((breakdown) => {
                  const createDate = dateFormat(breakdown?.date).full;
                  return (
                    <tr key={breakdown.id}>
                      <td>{createDate}</td>
                      <td>{breakdown?.name}</td>
                      <td className="w-fit">
                        <Link
                          to={`breakdown-preview/${breakdown.id}`}
                          className="flex w-fit p-2 border rounded-lg"
                        >
                          <img
                            src={Eye}
                            alt="see icon"
                            className="w-4 h-4"
                          />
                        </Link>
                      </td>
                      <td>
                        {breakdown?.price && breakdown?.price !== 'Non défini'
                          ? breakdown?.price + ' €'
                          : breakdown?.price}
                      </td>
                      <td>{breakdown?.status}</td>
                      <td className="flex items-center pt-4 space-x-4 justify-end">
                        <button
                          className="w-8 p-2 border rounded-lg border-gray-separate"
                          onClick={() => callDeleteBreakdown(breakdown)}
                        >
                          <img
                            src={DeleteIcon}
                            alt="delete icon"
                          />
                        </button>
                        <Link
                          to={`edit-breakdown/${breakdown.id}`}
                          className="float-right w-8 rounded-lg bg-gray-sidebar py-0.5 px-1 "
                        >
                          <img
                            src={More}
                            alt="more icon"
                          />
                        </Link>
                      </td>
                    </tr>
                  );
                })
              ) : (
                <tr>
                  <td
                    colSpan={5}
                    className="text-lg text-center"
                  >
                    La liste des pannes est vide. Veuillez ajouter une panne.
                  </td>
                </tr>
              )}
            </tbody>
          </Table>
        </div>
      </section>
      <Modal isVisible={showModal}>
        <div>
          <div className="pt-5 pl-5">
            <img
              src={AttentionIcon}
              alt="attention icon"
            />
            <p className="pl-5 pt-7">Supression de panne</p>
            <p className="px-5 pt-2 text-gray-admin">
              Êtes-vous sûre de vouloir supprimer cette panne ? Cette action est définitive.
            </p>
            <div className="text-center pt-7">
              <button
                className="px-12 py-3 mr-4 font-semibold border rounded-xl text-red-error"
                onClick={() => setShowModal(false)}
              >
                Annuler
              </button>
              <button
                className="px-10 py-3 text-white bg-red-error rounded-xl"
                onClick={removeBreakdown}
              >
                Supprimer
              </button>
            </div>
          </div>
        </div>
      </Modal>
    </>
  );
};

export default BreakDowns;

